/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  startupYearFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('startupYearFilterController', ['$scope',
      function ($scope) {
        $scope.componentName = "startupYearFilter";

        $scope.resetFilter = function () {
          delete $scope.criteria["startupYearFrom"];
          delete $scope.criteria["startupYearTo"];
        };

        $scope.removeStartupYearFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#startupYearFilter");
        };


        $scope.showInvalidMessage = function(){
          // this is not very nice looking logic - it is caused by the either/or/both
          // nature of the startup range filter as well as the fact that  zero
          // is valid but falsey

          // If I  can get  this subjected to some proper tests, I  might be able to
          // do something about the ugly chain of conditionals

          var showMessage = false
          if (!angular.isNumber($scope.criteria.startupYearFrom) && $scope.criteria.startupYearFrom != "")
            showMessage = true;

          if(!angular.isNumber($scope.criteria.startupYearTo) && $scope.criteria.startupYearTo != "" )
            showMessage = true;

          if (!$scope.criteria.startupYearTo && !$scope.criteria.startupYearFrom)
            showMessage = true;

          if (angular.isNumber($scope.criteria.startupYearFrom) && !$scope.criteria.startupYearTo)
            showMessage = false;

          if (angular.isNumber($scope.criteria.startupYearTo) && !$scope.criteria.startupYearFrom)
            showMessage = false;

          if(angular.isNumber($scope.criteria.startupYearFrom)
              && angular.isNumber($scope.criteria.startupYearTo)
              && $scope.criteria.startupYearTo <= $scope.criteria.startupYearFrom)
            showMessage = true;

          if ($scope.startupYearFilterForm.$pristine)
            showMessage = false;


          $scope.startupYearFilterForm.$setValidity("$valid", !(showMessage || $scope.startupYearFilterForm.$pristine))
          return showMessage;
        };

      }])
    .directive('startupYearFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/startupYearFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
            var txtStartupYearFrom = iElement.find('#txtStartupYearFrom')
            txtStartupYearFrom.attr('placeholder', txtStartupYearFrom.attr('placeholder-text'));

            var txtStartupYearTo = iElement.find('#txtStartupYearTo')
            txtStartupYearTo.attr('placeholder', txtStartupYearTo.attr('placeholder-text'));
          },

          controller: 'startupYearFilterController'
        };
      }]);
//------------------------------------------------------------------------

